/*@ngInject*/
const UICurrencyFormatterDirective = function ($timeout, $filter, currencyUtil, submissionConstant) {

    let linkFunction = function ($scope, $elm, $attrs, ngModelController) {

        let isEnabled,
            currencyFilter = $filter('currency'),
            currencyFormat,
            displayDollar,
            currencyRounding,
            element = $($elm),
            timeoutList = [],
            currencyCode;

        function run() {
            function floatStringFromCurrency(value) {
                let floatValue = value;
                floatValue = _.replace(floatValue, /\$/gi, '');
                floatValue = _.replace(floatValue, /,/gi, '');
                floatValue = _.replace(floatValue, _.get(currencyFormat, 'symbol', ''), '');
                return floatValue;
            }

            function handleFocus() {
                let strLength;
                if (ngModelController.$modelValue) {
                    let viewValue = floatStringFromCurrency(ngModelController.$viewValue);

                    ngModelController.$viewValue = viewValue;
                    ngModelController.$render();
                } else {
                    ngModelController.$viewValue = '';
                    ngModelController.$render();
                }
                strLength = ngModelController.$viewValue.length;
                $elm[0].setSelectionRange(strLength, strLength);
            }

            function handleBlur() {
                let value,
                    valueArray,
                    currencyValue,
                    fraction;

                if (!isNaN(ngModelController.$modelValue) && !_.isEmpty(ngModelController.$modelValue)) {
                    value = parseFloat(floatStringFromCurrency(ngModelController.$modelValue));

                    valueArray = _.split(value, '.');

                    if (currencyRounding === 'none') {
                        fraction = 2; //always display 2 digits when there is no rounding for currency

                        if(_.isNil(valueArray[1]) || valueArray[1] === 0) {
                            fraction = 0;
                            value = Math.round(valueArray[0]);
                        }
                    } else {
                        fraction = 0;
                        switch (currencyRounding) {
                            case 'nearest':
                                value = Math.round(value);
                                break;
                            case 'up':
                                value = Math.ceil(value);
                                break;
                            case 'down':
                                value = Math.floor(value);
                                break;
                        }
                    }

                    currencyValue = currencyFilter(value, currencyFormat.symbol, fraction, currencyFormat.suffixSymbol, currencyFormat.customFormat);
                    ngModelController.$viewValue = currencyValue;

                    ngModelController.$render();
                }
            }

            function handleKeydown(event) {
                if (!isKeyAllowed(event)) { //remove comma
                    return event.preventDefault();
                }
            }

            function isKeyAllowed(event) {
                let currentChar = event.keyCode || event.which;

                // allow TAB, ENTER, COMMA
                if (_.includes([9, 44, 13], currentChar)) {
                    return true;
                }

                return _.isNumber(_.parseInt(String.fromCharCode(currentChar)));
            }

            $scope.$watch($attrs.ngModel, function (newValue) {
                if (!element.is(':focus') && newValue) {
                    handleBlur();
                }
            });

            $scope.$on(submissionConstant.event.CURRENT_SUBMISSION_CHANGE, function (event, currentSubmission) {
                currencyCode = currentSubmission ? currentSubmission.currencyCode : null;
                currencyFormat = currencyUtil.getCurrencyFormat(currencyCode, displayDollar);

                if (!element.is(':focus')) {
                    handleBlur();
                } else {
                    handleFocus();
                }
            });

            element.on('focus', handleFocus);
            element.on('blur', handleBlur);
            element.on('keypress', handleKeydown);

            $scope.$on('$destroy', function () {
                element.off('focus', handleFocus);
                element.off('blur', handleBlur);
                element.off('keypress', handleKeydown);
            });
        }

        timeoutList.push($timeout(function () {
            isEnabled = $elm.hasClass('ui-currency-formatter');
            displayDollar = $elm.hasClass('ui-display-dollar');
            currencyRounding = $attrs.uiCurrencyFormatterRounding || 'none';
            currencyCode = $attrs.uiCurrencyCode;

            if (isEnabled) {
                currencyFormat = currencyUtil.getCurrencyFormat(currencyCode, displayDollar);
                run();
            }

        }, 300));

        $scope.$on('$destroy', function () {
            _.each(timeoutList, function (item) {
                $timeout.cancel(item);
            });
        });

    };

    return {
        restrict: 'A',
        require: 'ngModel',
        link: linkFunction
    };
};

angular.module('umCore')
    .directive('uiCurrencyFormatter', UICurrencyFormatterDirective);
